import {
	PULL_DATA_ERROR,
	PULL_DATA_LOADING,
	PULL_DATA_SUCCESS,
} from '../types';

const INITIAL_STATE = {
	loading: false,
	data: null,
	error: null,
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case PULL_DATA_LOADING:
			return {
				...state,
				loading: true,
			};
		case PULL_DATA_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			};
		case PULL_DATA_ERROR:
			return {
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
